export const isNumber = value => !isNaN(value) && isFinite(value);
